import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
const testimonials = ['https://cdn.magicpatterns.com/uploads/pJjxTg2cM1hg9yYu2zwQ3B/ChatGPT_Image_1_may_2026,_00_31_47.png', 'https://cdn.magicpatterns.com/uploads/qbYF72HQ9ehpENJuJuY7S6/WhatsApp_Image_2026-05-01_at_00.28.31.jpg', 'https://cdn.magicpatterns.com/uploads/jBr2rXywj75ZZDD58Y9T4V/ChatGPT_Image_1_may_2026,_00_35_44.png', 'https://cdn.magicpatterns.com/uploads/enDoLRr7zxwKiBB45uyhks/ChatGPT_Image_1_may_2026,_00_38_49.png'];
export function TestimonialsCarousel() {
  const [current, setCurrent] = useState(0);
  const prev = () => {
    setCurrent(c => (c - 1 + testimonials.length) % testimonials.length);
  };
  const next = () => {
    setCurrent(c => (c + 1) % testimonials.length);
  };
  return <section className="w-full bg-white px-4 md:px-8 py-16" data-id="element-333">
      <div className="max-w-[900px] mx-auto text-center" data-id="element-334">
        {/* Title */}
        <h2 className="font-['Playfair_Display',_serif] text-3xl md:text-4xl lg:text-[42px] font-bold text-[#1a1a1a] leading-tight" data-id="element-335">
          Resultados Reales (No opiniones)
        </h2>
        <div className="w-16 h-1 bg-[#2d6a2e] mx-auto mt-4 mb-10" data-id="element-336"></div>

        {/* Carousel */}
        <div className="relative overflow-hidden" data-id="element-337">
          <div className="flex transition-transform duration-500 ease-in-out" style={{
          transform: `translateX(-${current * 100}%)`
        }} data-id="element-338">
            {testimonials.map((src, index) => <div key={index} className="w-full flex-shrink-0 flex justify-center px-4" data-id="element-339">
                <img src={src} alt={`Testimonio ${index + 1}`} className="max-w-[420px] w-full h-auto rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.08)]" data-id="element-340" />
              </div>)}
          </div>
        </div>

        {/* Arrow Buttons */}
        <div className="flex justify-center gap-3 mt-8" data-id="element-341">
          <button onClick={prev} className="w-11 h-11 rounded-full bg-[#4caf50] flex items-center justify-center hover:bg-[#43a047] transition-colors" aria-label="Testimonio anterior" data-id="element-342">
            <ChevronLeftIcon className="w-5 h-5 text-white" data-id="element-343" />
          </button>
          <button onClick={next} className="w-11 h-11 rounded-full bg-[#4caf50] flex items-center justify-center hover:bg-[#43a047] transition-colors" aria-label="Testimonio siguiente" data-id="element-344">
            <ChevronRightIcon className="w-5 h-5 text-white" data-id="element-345" />
          </button>
        </div>
      </div>
    </section>;
}